import { gql } from '@apollo/client'
import { companyManagerAppraisalMeetingStatusTableRowFragment } from '../fragments/appraisalMeetingStatusTable.fragments'

/** Appraisal season year for all subordinates (single value or null); independent of monitoring filters. */
export const COMPANY_MANAGER_DASHBOARD_AS_YEAR = gql`
  query CompanyManagerDashboardASYear($companyId: HashedId!, $country: Country!, $userDashboardRoles: [RoleName!]!) {
    companyManagerDashboardASYear(companyId: $companyId, userDashboardRoles: $userDashboardRoles)
    employeeLevels: getCountryEmployeeLevels(country: $country)
  }
`

/** Company Manager Dashboard — appraisal meeting status (current appraisal season). */
export const COMPANY_MANAGER_DASHBOARD_APPRAISAL_MEETING_STATUS = gql`
  query CompanyManagerDashboardAppraisalMeetingStatus($companyId: HashedId!, $userDashboardRoles: [RoleName!]!) {
    companyManagerDashboardAppraisalMeetingStatus(companyId: $companyId, userDashboardRoles: $userDashboardRoles) {
      companyId
      ongoingAppraisalUpdateAfterLatestConfirmedMeetingCount
      rows {
        ...CompanyManagerAppraisalMeetingStatusTableRowFields
      }
    }
  }
  ${companyManagerAppraisalMeetingStatusTableRowFragment}
`
